// Simple Toast Event Bus to decouple UI from callers
export type ToastType = 'success' | 'error' | 'info' | 'warning'

export interface ToastEvent {
  type: ToastType
  message: string
  title?: string
}

// Subscribers registry
const listeners = new Set<(event: ToastEvent) => void>()

export function subscribeToToasts(listener: (event: ToastEvent) => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function emitToast(event: ToastEvent) {
  listeners.forEach((cb) => {
    try {
      cb(event)
    } catch (err) {
      // keep other listeners alive
      console.error('[toastBus] listener error:', err)
    }
  })
}

export const toastBus = {
  success: (message: string, title?: string) => emitToast({ type: 'success', message, title }),
  error: (message: string, title?: string) => emitToast({ type: 'error', message, title }),
  info: (message: string, title?: string) => emitToast({ type: 'info', message, title }),
  warning: (message: string, title?: string) => emitToast({ type: 'warning', message, title }),
}

export default toastBus
